/**
 * Where each onboarding document is filed.
 *
 * Slot keys and upload file types mirror the backend
 * (CompanyTemplateConfigService.ONBOARDING_* and OnboardingFile.ALLOWED_FILE_TYPES);
 * the category is what puts the document into the file tree.
 */
export interface OnboardingDocumentSlotConfig {
  series: string;
  fileType: string;
  category: string;
}

export interface OnboardingDocumentSettings {
  documents: Record<string, OnboardingDocumentSlotConfig>;
  uploads: Record<string, string>;
}

export const ONBOARDING_DOCUMENT_SLOTS: {
  slotKey: string;
  labelKey: string;
}[] = [
  {
    slotKey: "onboarding_hiring_questionnaire",
    labelKey: "onboarding_hiring_questionnaire",
  },
  {
    slotKey: "onboarding_esignature_agreement",
    labelKey: "onboarding_esignature_agreement",
  },
  {
    slotKey: "onboarding_employee_questionnaire",
    labelKey: "onboarding_employee_questionnaire",
  },
  { slotKey: "onboarding_application", labelKey: "onboarding_application" },
  {
    slotKey: "onboarding_gdpr_statement",
    labelKey: "onboarding_gdpr_statement",
  },
  {
    slotKey: "onboarding_contract_standard",
    labelKey: "onboarding_contract_standard",
  },
  {
    slotKey: "onboarding_contract_director",
    labelKey: "onboarding_contract_director",
  },
];

export const ONBOARDING_UPLOAD_TYPES: {
  fileType: string;
  labelKey: string;
}[] = [
  { fileType: "id_document", labelKey: "id_document" },
  { fileType: "birth_certificate", labelKey: "birth_certificate" },
  { fileType: "drivers_license", labelKey: "drivers_license" },
  { fileType: "health_certificate", labelKey: "health_certificate" },
  { fileType: "education_document", labelKey: "education_document" },
  { fileType: "medical_certificate", labelKey: "medical_certificate" },
  { fileType: "other", labelKey: "onboarding_upload_other" },
  { fileType: "step_2_signed_asice", labelKey: "onboarding_signed_container" },
];
